import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  URLBuilder1hwx1b9569i61 as URLBuilder,
  takeFromkqlcz7c6dx2r as takeFrom,
} from '../../../../../ktor-ktor-http/io/ktor/http/URLUtils.mjs';
import { ParametersBuilder1ry9ntvvg567r as ParametersBuilder } from '../../../../../ktor-ktor-http/io/ktor/http/Parameters.mjs';
import { appendAlltwnjnu28pmtx as appendAll } from '../../../../../ktor-ktor-utils/io/ktor/util/StringValues.mjs';
import { first58ocm7j58k3q as first } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { checkBuilderCapacity1h6g02949wvv as checkBuilderCapacity } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
import { PipelineContext34fsb0mycu471 as PipelineContext } from '../../../../../ktor-ktor-utils/io/ktor/util/pipeline/PipelineContext.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import { Phases_getInstance153dg9ipormlv as Phases_getInstance } from '../request/HttpRequestPipeline.mjs';
import { HeadersBuilder3h7sn3kkvu98m as HeadersBuilder } from '../../../../../ktor-ktor-http/io/ktor/http/Headers.mjs';
import { URLBuilder2mz8zkz4u9ray as URLBuilder_0 } from '../../../../../ktor-ktor-http/io/ktor/http/URLBuilder.mjs';
import { AttributesJsFn25rjfgcprgprf as AttributesJsFn } from '../../../../../ktor-ktor-utils/io/ktor/util/Attributes.web.mjs';
import { takeFrom3rd40szpqy350 as takeFrom_0 } from '../../../../../ktor-ktor-http/io/ktor/http/URLParser.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_LOGGER() {
  _init_properties_DefaultRequest_kt__yzsodq();
  return LOGGER;
}
var LOGGER;
function defaultRequest(_this__u8e3s4, block) {
  _init_properties_DefaultRequest_kt__yzsodq();
  var tmp = Plugin_getInstance();
  return _this__u8e3s4.e5i(tmp, ($this$install) => {
    block($this$install);
    return Unit_instance;
  });
}
function mergeUrls($this, baseUrl, requestUrl) {
  if (requestUrl.u53_1 == null) {
    requestUrl.u53_1 = baseUrl.p54_1;
  }
  // Inline function 'kotlin.text.isNotEmpty' call
  var this_0 = requestUrl.r53_1;
  if (charSequenceLength(this_0) > 0)
    return Unit_instance;
  var resultUrl = URLBuilder(baseUrl);
  // Inline function 'kotlin.with' call
  resultUrl.u53_1 = requestUrl.u53_1;
  if (!(requestUrl.t53_1 === 0)) {
    resultUrl.z54(requestUrl.t53_1);
  }
  resultUrl.y53_1 = concatenatePath(Plugin_getInstance(), resultUrl.y53_1, requestUrl.y53_1);
  // Inline function 'kotlin.text.isNotEmpty' call
  var this_1 = requestUrl.x53_1;
  if (charSequenceLength(this_1) > 0) {
    resultUrl.x53_1 = requestUrl.x53_1;
  }
  // Inline function 'kotlin.apply' call
  var this_2 = ParametersBuilder();
  appendAll(this_2, resultUrl.z53_1);
  var defaultParameters = this_2;
  resultUrl.m55(requestUrl.z53_1);
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = defaultParameters.j4o().u1();
  while (_iterator__ex2g4s.v1()) {
    var element = _iterator__ex2g4s.w1();
    // Inline function 'kotlin.collections.component1' call
    var key = element.r3();
    // Inline function 'kotlin.collections.component2' call
    var values = element.s3();
    if (!resultUrl.z53_1.q4o(key)) {
      resultUrl.z53_1.k4o(key, values);
    }
  }
  takeFrom(requestUrl, resultUrl);
}
function concatenatePath($this, parent, child) {
  if (child.s1())
    return parent;
  if (parent.s1())
    return child;
  // Inline function 'kotlin.text.isEmpty' call
  var this_0 = first(child);
  if (charSequenceLength(this_0) === 0)
    return child;
  // Inline function 'kotlin.collections.buildList' call
  // Inline function 'kotlin.collections.buildListInternal' call
  var capacity = (parent.v2() + child.v2() | 0) - 1 | 0;
  checkBuilderCapacity(capacity);
  // Inline function 'kotlin.apply' call
  var this_1 = ArrayList().m2(capacity);
  var inductionVariable = 0;
  var last = parent.v2() - 1 | 0;
  if (inductionVariable < last)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      this_1.n2(parent.w2(index));
    }
     while (inductionVariable < last);
  this_1.z2(child);
  return this_1.k8();
}
var DefaultRequest$Plugin$install$slambdaClass;
function DefaultRequest$Plugin$install$slambda() {
  if (DefaultRequest$Plugin$install$slambdaClass === VOID) {
    class $ {
      constructor($plugin) {
        this.h5n_1 = $plugin;
      }
      z5g($this$intercept, it, $completion) {
        var originalUrlString = $this$intercept.o4r_1.t5g_1.toString();
        // Inline function 'kotlin.apply' call
        var this_0 = new (DefaultRequestBuilder())();
        appendAll(this_0.i5n_1, $this$intercept.o4r_1.v5g_1);
        var userHeaders = this_0.i5n_1.n37();
        this.h5n_1.l5n_1(this_0);
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = userHeaders.j4o().u1();
        while (_iterator__ex2g4s.v1()) {
          var element = _iterator__ex2g4s.w1();
          $l$block_0: {
            // Inline function 'kotlin.collections.component1' call
            var key = element.r3();
            // Inline function 'kotlin.collections.component2' call
            var oldValues = element.s3();
            var newValues = this_0.i5n_1.p4o(key);
            if (newValues == null) {
              this_0.i5n_1.k4o(key, oldValues);
              break $l$block_0;
            }
            if (equals(newValues, oldValues) || key === 'Cookie') {
              break $l$block_0;
            }
            this_0.i5n_1.y4o(key);
            this_0.i5n_1.k4o(key, oldValues);
            this_0.i5n_1.x4o(key, newValues);
          }
        }
        var defaultRequest = this_0;
        var defaultUrl = defaultRequest.j5n_1.n37();
        mergeUrls(Plugin_getInstance(), defaultUrl, $this$intercept.o4r_1.t5g_1);
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s_0 = defaultRequest.k5n_1.d4n().u1();
        while (_iterator__ex2g4s_0.v1()) {
          var element_0 = _iterator__ex2g4s_0.w1();
          if (!$this$intercept.o4r_1.y5g_1.y4m(element_0)) {
            $this$intercept.o4r_1.y5g_1.z4m(element_0 instanceof AttributeKey() ? element_0 : THROW_CCE(), defaultRequest.k5n_1.w4m(element_0));
          }
        }
        $this$intercept.o4r_1.v5g_1.f5();
        $this$intercept.o4r_1.v5g_1.v4o(defaultRequest.i5n_1.n37());
        get_LOGGER().s4s('Applied DefaultRequest to ' + originalUrlString + '. New url: ' + $this$intercept.o4r_1.t5g_1.toString());
        return Unit_instance;
      }
      vd(p1, p2, $completion) {
        var tmp = p1 instanceof PipelineContext() ? p1 : THROW_CCE();
        return this.z5g(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    DefaultRequest$Plugin$install$slambdaClass = $;
  }
  return DefaultRequest$Plugin$install$slambdaClass;
}
function DefaultRequest$Plugin$install$slambda_0($plugin) {
  var i = new (DefaultRequest$Plugin$install$slambda())($plugin);
  var l = ($this$intercept, it, $completion) => i.z5g($this$intercept, it, $completion);
  l.$arity = 2;
  return l;
}
var PluginClass;
function Plugin() {
  if (PluginClass === VOID) {
    class $ {
      constructor() {
        Plugin_instance = this;
        var tmp = this;
        // Inline function 'io.ktor.util.AttributeKey' call
        var name = 'DefaultRequest';
        // Inline function 'io.ktor.util.reflect.typeInfo' call
        var tmp_0 = getKClass(DefaultRequest());
        // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
        var tmp_1;
        try {
          tmp_1 = createKType(getKClass(DefaultRequest()), arrayOf([]), false);
        } catch ($p) {
          var tmp_2;
          if ($p instanceof Error) {
            var _unused_var__etf5q3 = $p;
            tmp_2 = null;
          } else {
            throw $p;
          }
          tmp_1 = tmp_2;
        }
        var tmp$ret$0 = tmp_1;
        var tmp$ret$1 = new (TypeInfo())(tmp_0, tmp$ret$0);
        tmp.m5n_1 = new (AttributeKey())(name, tmp$ret$1);
      }
      r3() {
        return this.m5n_1;
      }
      n5n(block) {
        return new (DefaultRequest())(block);
      }
      c5i(block) {
        return this.n5n(block);
      }
      o5n(plugin, scope) {
        var tmp = Phases_getInstance().n5m_1;
        scope.c5g_1.s4r(tmp, DefaultRequest$Plugin$install$slambda_0(plugin));
      }
      d5i(plugin, scope) {
        return this.o5n(plugin instanceof DefaultRequest() ? plugin : THROW_CCE(), scope);
      }
    }
    initMetadataForObject($, 'Plugin');
    PluginClass = $;
  }
  return PluginClass;
}
var Plugin_instance;
function Plugin_getInstance() {
  if (Plugin_instance === VOID)
    new (Plugin())();
  return Plugin_instance;
}
var DefaultRequestBuilderClass;
function DefaultRequestBuilder() {
  if (DefaultRequestBuilderClass === VOID) {
    class $ {
      constructor() {
        this.i5n_1 = new (HeadersBuilder())();
        this.j5n_1 = new (URLBuilder_0())();
        this.k5n_1 = AttributesJsFn(true);
      }
      n50() {
        return this.i5n_1;
      }
      p5n(urlString) {
        takeFrom_0(this.j5n_1, urlString);
      }
    }
    initMetadataForClass($, 'DefaultRequestBuilder');
    DefaultRequestBuilderClass = $;
  }
  return DefaultRequestBuilderClass;
}
var DefaultRequestClass;
function DefaultRequest() {
  if (DefaultRequestClass === VOID) {
    class $ {
      constructor(block) {
        Plugin_getInstance();
        this.l5n_1 = block;
      }
    }
    initMetadataForClass($, 'DefaultRequest');
    DefaultRequestClass = $;
  }
  return DefaultRequestClass;
}
var properties_initialized_DefaultRequest_kt_au5efk;
function _init_properties_DefaultRequest_kt__yzsodq() {
  if (!properties_initialized_DefaultRequest_kt_au5efk) {
    properties_initialized_DefaultRequest_kt_au5efk = true;
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.DefaultRequest');
  }
}
//region block: exports
export {
  defaultRequest as defaultRequest2ux1d5xxixv6z,
};
//endregion

//# sourceMappingURL=DefaultRequest.mjs.map
